// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

/**
 * Shared cache TTL authority for frontend stores.
 *
 * All stores that implement client-side cache-busting against a remote
 * configuration or session-list endpoint MUST consume the TTL from this
 * single source.  Per-store micro-constants that happen to carry the same
 * numeric value are still a scattered authority and are forbidden.
 *
 * If a store genuinely needs a different TTL, it must either:
 *   - add a named export here with a documented reason, or
 *   - be justified as a separate cache domain in an ADR.
 */

/** Default cache TTL in milliseconds for remote config / session-list fetches. */
export const CACHE_TTL_MS = 8000;

/**
 * Cache TTL for the model registry / provider catalog domain.
 *
 * The model registry catalog and the provider catalog are heavier, less
 * frequently changing endpoints that the report (CD-4) flagged as carrying a
 * scattered local `5 * 60 * 1000` literal in two stores.  This is the single
 * named authority for that 5-minute cache domain; stores that need it must
 * import this export instead of re-declaring the literal.
 */
export const MODEL_CACHE_TTL_MS = 5 * 60 * 1000;
